import { BulkActionType } from './types'

/**
 * The bulk-action types that operate on invoices. The in-flight panel derives
 * its monitored types from each entity's config, so this list exists only for
 * `useUnreviewedBulkActionsForInvoice`, which filters bulk actions for a
 * single invoice.
 */
export const INVOICE_BULK_ACTION_TYPES: BulkActionType[] = [
  'UPDATE_INVOICES_STATUS',
  'VOID_INVOICES',
  'RECALCULATE_INVOICES',
  'DOWNLOAD_INVOICES',
  'FINALISE_INVOICES',
  'FINALISE_AND_SEND_INVOICES',
  'SEND_INVOICES',
  'MARK_INVOICES_AS_SENT',
  'CONVERT_INVOICES_TO_DRAFT',
  'DELETE_INVOICES'
]
